import { isFeatureEnabled } from '@lumapps/features';

/**
 * Check the layout v2 feature flag.
 */
export const isLayoutEnabled = isFeatureEnabled('layout-v2');
